export default {
  NINE: "9",
  EIGHTEEN: "18",
  TEN_SEVENTEEN: "10-17",
};
